// src/utils/chartModal.js
// Управление модальным окном для увеличения графиков

import { makeHistogram, makePie, makeLine } from "./chartRenderers";

export function initializeModal(root, chartRegistry) {
  const modal = root.querySelector("#chart-modal");
  const modalBody = modal?.querySelector(".modal-body");
  const modalTitle = modal?.querySelector(".modal-title");
  const closeBtn = modal?.querySelector(".modal-close");

  function openModalFor(cardId) {
    const meta = chartRegistry.get(cardId);
    if (!meta || !modal || !modalBody || !modalTitle) return;

    modalBody.innerHTML = "";

    if (meta.type === "pie") {
      const section = document.createElement("section");
      section.className = "card pie-modal-card";
      section.innerHTML = `
        <div class="pie-layout">
          <div class="chart pie-chart">
            <div class="pie-canvas">
              <svg viewBox="-112 -112 224 224" preserveAspectRatio="xMidYMid meet">
                <circle class="ring" r="100"></circle>
                <g id="slices"></g>
                <circle r="58" fill="#fff" stroke="#e6eaf2" stroke-width="1.5"></circle>
                <text id="sumLabel" text-anchor="middle" dy="4.5" font-size="16" fill="#4a5366" style="font-weight:600"></text>
              </svg>
            </div>
            <div class="tooltip" aria-hidden="true"></div>
          </div>
          <div class="legend pie-legend"></div>
        </div>`;
      modalBody.appendChild(section);
      modal.classList.add("show");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      modalTitle.textContent = "Trenajyor ulushi";
      makePie(section, meta.data, chartRegistry, root);
    } else {
      const section = document.createElement("section");
      section.className = "card";
      section.style.border = "none";
      section.style.boxShadow = "none";
      section.style.padding = "6px";
      section.innerHTML = `
        <div class="chart flex-center" data-aspect="960/460">
          <svg viewBox="0 0 960 460" preserveAspectRatio="xMidYMid meet"></svg>
          <div class="tooltip" aria-hidden="true"></div>
        </div>`;
      modalBody.appendChild(section);
      modal.classList.add("show");
      modal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      modalTitle.textContent =
        cardId === "hist1-card"
          ? "Kunlik qatnashuvchilar"
          : cardId === "hist2-card"
            ? "O'rtacha baho"
            : meta.type === "line"
              ? "Yuqori baholar soni"
              : meta.type === "marks"
                ? "Baholar"
                : "Diagramma";

      if (meta.type === "hist") {
        makeHistogram(section, meta.data, chartRegistry, root);
      } else if (meta.type === "marks") {
        // Для marks используем makeHistogram
        makeHistogram(section, meta.data, chartRegistry, root);
      } else {
        const rows = meta.data.map((d) => ({
          t: new Date(d.t),
          y: d.y,
        }));
        makeLine(section, rows, chartRegistry, root);
      }
    }
  }

  function closeModal() {
    if (!modal || !modalBody) return;
    modal.classList.remove("show");
    modal.setAttribute("aria-hidden", "true");
    modalBody.innerHTML = "";
    document.body.style.overflow = "";
  }

  if (closeBtn) closeBtn.addEventListener("click", closeModal);
  if (modal)
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal?.classList.contains("show"))
      closeModal();
  });

  // Регистрируем обработчик для zoom-btn кнопок
  root.querySelectorAll(".zoom-btn").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const target = btn.dataset.target;
      if (target) {
        openModalFor(target);
      }
    });
  });

  return { openModalFor, closeModal };
}
